<template>
  <div>
    <div v-if="errors.length" class="alert alert-danger">
      <ul>
        <li v-for="error in errors" :key="error.msg">
          {{ error.msg }}
        </li>
      </ul>
    </div>
    <b-modal id="modal1" ref="myModalRef">
      <p class="my-4">
        Your balance must be at least $20 before<br />
        you can withdraw funds
      </p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="danger" @click="close">
          Close
        </b-btn>
      </div>
    </b-modal>
    <p v-if="data.user" style="text-align:center;font-size:20px">
      Total Points: {{ data.user.points }}
      <br />
      Points Today: {{ data.pointsDay }}
      <br />
      Total earnings: ${{ (data.earnedTotal / 100).toFixed(2) }}
      <br />
      Current Balance: ${{
        ((data.earnedTotal - data.withdrawedTotal) / 100).toFixed(2)
      }}
    </p>
    <div style="text-align:center;">
      <b-button @click="withdraw">Withdraw Funds</b-button>
    </div>
    <div v-if="data.withdrawals && data.withdrawals.length > 0">
      <div style="text-align:center;"><br />Withdrawals</div>
      <b-table striped hover :items="data.withdrawals" :fields="fields">
      </b-table>
    </div>
  </div>
</template>

<script>
import API from '@/api';

export default {
  name: 'Account',
  props: {
    uuid: {
      type: [String],
      required: true
    },
    md5: {
      type: [String],
      required: true
    },
    timezone: {
      type: [String]
    }
  },
  data() {
    return {
      data: {},
      errors: [],
      fields: {
        createdAt: {
          label: 'Date',
          formatter: date => {
            if (!date) return null;
            if (typeof date !== 'object') {
              date = new Date(date);
            }
            const year = date.getFullYear();
            const day = date.getDate();
            const month = date.getMonth();
            return `${month}/${day}/${year}`;
          }
        },
        amount: {
          label: 'Amount',
          formatter: value => {
            return '$' + (value / 100).toFixed(2);
          }
        }
      }
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.loadData();
    next();
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      API.get(
        'account/' + this.uuid + '/' + this.md5 + '/' + this.timezone
      ).then(res => {
        this.submited = false;

        if (res.status === 'ok') {
          this.data = res.data;
        } else {
          this.errors = res.errors;
        }
      });
    },

    withdraw() {
      if (this.data.earnedTotal - this.data.withdrawedTotal < 2000) {
        this.$refs.myModalRef.show();
      } else {
        this.$router.push({ name: 'CreateWithdrawRequest' });
      }
    },
    close() {
      this.$refs.myModalRef.hide();
    }
  }
};
</script>

<style scoped></style>
